import { ALPHA_NUMERIC_AND_SPACE, NUMERIC } from "../../constants";
import { ContractorType } from "../../pages/contractor/type";
import { Validations } from "../../types/shared/Validation";

const validateBasePremium = (basePremium: number) => {
  if (basePremium === 0) {
    return "Must be more than 0";
  }
  return null;
};

export const contractorDetailsValidations: Validations<ContractorType> = {
  fields: {
    companyName: {
      required: true,
      length: {
        maxLength: 200,
        message: "Text exceeds max. length",
      },
      pattern: {
        regex: ALPHA_NUMERIC_AND_SPACE,
        message: " ",
      },
    },
    uenNumber: {
      required: true,
      pattern: {
        regex: ALPHA_NUMERIC_AND_SPACE,
        message: " ",
      },
    },
    number: {
      required: true,
      pattern: {
        regex: ALPHA_NUMERIC_AND_SPACE,
        message: " ",
      },
    },
    streetName: {
      required: true,
      pattern: {
        regex: ALPHA_NUMERIC_AND_SPACE,
        message: " ",
      },
    },
    floorNumber: {
      required: false,
      pattern: {
        regex: ALPHA_NUMERIC_AND_SPACE,
        message: " ",
      },
    },
    unitNumber: {
      required: false,
      pattern: {
        regex: ALPHA_NUMERIC_AND_SPACE,
        message: " ",
      },
    },
    postalCode: {
      required: true,
      pattern: {
        regex: NUMERIC,
        message: "Must be digits",
      },
    },
    directors: {
      array: {
        name: {
          required: true,
          length: {
            maxLength: 50,
            message: "Text exceeds max. length",
          },
          pattern: {
            regex: ALPHA_NUMERIC_AND_SPACE,
            message: " ",
          },
        },
        NRIC: {
          required: true,
          length: {
            maxLength: 12,
            message: "Text exceeds max. length",
          },
          pattern: {
            regex: ALPHA_NUMERIC_AND_SPACE,
            message: " ",
          },
        },
      },
    },
    guarantors: {
      array: {
        name: {
          length: {
            maxLength: 50,
            message: "Text exceeds max. length",
          },
          pattern: {
            regex: ALPHA_NUMERIC_AND_SPACE,
            message: " ",
          },
        },
        NRIC: {
          length: {
            maxLength: 12,
            message: "Text exceeds max. length",
          },
          pattern: {
            regex: ALPHA_NUMERIC_AND_SPACE,
            message: " ",
          },
        },
      },
    },
  },
};

export const foreignWorkerBondValidations: Validations<Partial<ContractorType>> = {
  fields: {
    agents: {
      array: {
        agentCode: {
          required: true,
          pattern: {
            regex: ALPHA_NUMERIC_AND_SPACE,
            message: " ",
          },
        },
        basePremiumCP14: {
          custom: {
            validate: basePremiumRate => {
              let error: string | null = null;
              error = error || validateBasePremium(basePremiumRate as number);
              return error;
            },
          },
        },
        basePremiumNCP26: {
          custom: {
            validate: basePremiumRate => {
              let error: string | null = null;
              error = error || validateBasePremium(basePremiumRate as number);
              return error;
            },
          },
        },
      },
    },
  },
};
